export default {
  guide: {
    start: 'Start',
    whatsNext: "What's next?",
    dontShowAgain: "Don't show this popup again",
    needHelp: 'Need help',
    userManual: 'User Manual',
    chooseFormat: 'Choose your preferred format',
    pdfManual: 'PDF Manual',
    downloadPdf: 'Download & read offline',
    videoTutorial: 'Video Tutorial',
    watchStepByStep: 'Watch step-by-step guide',
    firstStepTitle: 'Welcome! We’ll guide you through your first steps.',
    activationKey: {
      title: 'New activation keys have been successfully registered.',
      description:
        'Send the activation keys to the farmers/data collectors so they can register under your organization.',
      nextStep: 'Click on the Action button to select the format you want to share the keys.',
    },
    dashboard: {
      userManagement: 'User Management',
      userManagementDescription: 'User Management section allows you to:',
      listUser: 'View the current list of mobile and admin users',
      addUser: 'Add new users or invite users with Activation Keys',
      managePermission: 'Manage permissions, membership plans and roles',
      farmManagement: 'Farm Management',
      farmManagementDescription: 'Go to Farm Management section to:',
      listFarm: 'View the list of registered farms and farmers',
      addFarm: 'Add New Farms one-by-one or in bulk',
      title: 'Dashboard',
      description:
        'As you are onboarding more users and farms, you will be able to see the summary on the main dashboard.',
    },
    ddsDashboard: {
      title: 'Start with “Create New Due Diligence Report” section to get started.',
      alreadyHaveFarm: 'Already have farm data?',
      description:
        'You will have an option to add your farm data during the second step of the "Create New Diligence Report" process.',
      createNewReport: 'Create New Report',
      creatingReport: 'Creating a Due Diligence Report',
      sharingWithOperator: 'Sharing with Operator',
      riskMitigation: 'Risk Mitigation',
    },
    productionPlace: {
      title: 'Upload your farm data',
      description: 'Upload your farm data one-by-one or in bulk by clicking on "Add New" button.',
      allowedFormat: 'Currently, we accept the following formats for bulk data upload:',
    },
    reportDetail: {
      title: 'First, please fill out the details regarding your report.',
      description: 'Need help? Check out our user guides (pdf or video) by clicking here:',
      nextStep: 'Once done, click on "Next" to proceed to the step where you can upload your farm production data.',
    },
    adminRegistered: {
      title: 'New admin user has been successfully registered.',
      description:
        'Send the activation keys to the farmers/data collectors so they can register under your organization.',
      nextStep: "What's next? Start onboarding farmers and data collectors.",
    },
  },
};
